import React from 'react';
import { useI18n } from '../contexts/I18nContext';
import { Button } from './ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Loader2 } from 'lucide-react';

export function DeleteShipmentDialog({ open, deleteDialog, deleting, onCancel, onConfirm }) {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={(o) => !deleting && onCancel(!o)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('shipments.deleteShipmentTitle')}</DialogTitle>
          <DialogDescription>
            {t('shipments.deleteShipmentConfirm')} <strong>{deleteDialog.mbl}</strong>
            {deleteDialog.clientName && <> {t('shipments.deleteShipmentOf')} <strong>{deleteDialog.clientName}</strong></>}?
            <br /><br />
            {t('shipments.deleteShipmentWarn')}
            <span className="text-destructive font-medium"> {t('shipments.deleteIrreversible')}</span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onCancel(false)} disabled={deleting}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={deleting}
            data-testid="confirm-delete-btn"
          >
            {deleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t('shipments.deleting')}
              </>
            ) : (
              t('common.delete')
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
